import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
// import {LinkContainer} from 'react-router-bootstrap'
import {Glyphicon, Button} from 'react-bootstrap'
import ToolTip from '../components/ToolTip.js'
import ClickOutHandler from 'react-onclickout'
import IdeaProfileField from '../components/IdeaProfileField'
import Logger from '../stores/Logger'
import './css/UserProfile.css'

class UserProfile extends Component {

    constructor(props) {
        super(props)
        this.changeName = this.changeName.bind(this)
        this.onClickOut = this.onClickOut.bind(this)
        this.userProfileImage = this.userProfileImage.bind(this)
        this.state = {
            didBuy:false,
            showInput: false,
            name: '',
            url: '',
        }
    }
    componentDidMount(){
        const {stores} = this.props
        const {authStore} = stores
        const user = authStore.authUser()
        this.setState({
            name: user.displayName,
        })
    }
    changeName(e, userId, photoURL){
        const {stores} = this.props
        const {authStore} = stores
        if(this.state.name !== ''){
            const substring = 'https://ui-avatars.com/api/'
            const defaultUrl = '.pre.do/DefaultProfilePic.png'

            if(photoURL && (photoURL === '' || photoURL.includes(substring) || photoURL.includes(defaultUrl))){
                this.onNewImage(`https://ui-avatars.com/api/?name=${this.state.name}&color=707070&background=cccccc&size=60`)
            }
            Logger.trackEvent('changeUserName', 'name', this.state.name)
            authStore.updateDisplayName(this.state.name)
            this.setState({
                showInput: false,
            })
            this.forceUpdate()
        }
    }
    
    onClickOut(e) {
        this.setState({
            showInput: false,
        })
    }

    onInputChange(value){
        this.setState({
            name: value,
        })
    }

    onPressEnter(e, userId, photoURL){
        if(e.charCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            Logger.trackEvent('changeUserNameEnter')
            this.changeName(e, userId, photoURL)
        } 
    }
    onNewImage(url){
        const {stores} = this.props
        const {authStore} = stores
        Logger.trackEvent('onNewUserProfileImage','url',url)
        authStore.updateProfileImage(url)
        this.setState({
            url: url,
        })
    }
    onImageRejected(file){
        const {stores} = this.props
        const {store} = stores
        Logger.trackEvent('imageRejected', 'file', file)
        store.errorAlert = 'Image file '+file+' not PNG or JPEG format. Please try another image.'
        window.setTimeout(() => { store.errorAlert = undefined }, 5000)
    }

    userProfileImage(photoURL){
        if(this.state.url === ''){
            return photoURL
        }
        else{
            return this.state.url
        }
    }

    render() {
        const {stores} = this.props
        const {authStore} = stores
        const user = authStore.authUser()
        const userProfile = authStore.userProfile()
        const userId = user.uid
        let assignedTeams = authStore.auth.assignedTeams
        let photoURL = null
        if (userProfile) {
            photoURL = userProfile.photoURL ? userProfile.photoURL : user.photoURL
        }
        // const onFreePlan = authStore.onFreePlan()


        return (
            <div className='userProfileTitle'>

                <div>
                    <h1>My profile info</h1>
                </div>

                <div className='divInlinePhoto'>       
                        <div>
                            <IdeaProfileField
                                onNewImage={this.onNewImage.bind(this)}
                                onImageRejected={this.onImageRejected.bind(this)}
                                imageUrl={this.userProfileImage(photoURL)}
                                imageId={1}
                                uploadText={'Change your profile photo'}
                                imageHeight={180}
                                userName={this.state.name}
                            />      
                        </div>
                </div>

                <div className='divInline'>
                    <div>
                        <h4 style={{display: 'inline-block'}}>Name: </h4>
                        {this.state.showInput === false &&
                        <div onClick={(e) => this.setState({showInput: true})} style={{display: 'inline-block'}}>
                            <h4 style={{display: 'inline-block', cursor: 'pointer', marginLeft: 5+'px'}}>{this.state.name}</h4>
                            <ToolTip style={{display: 'inline-block'}} tipText='Change your name'>
                                <Glyphicon glyph='pencil' style={{marginLeft: 5+'px', color:'gray',fontSize:15}}/>
                            </ToolTip>
                        </div>
                        }

                        {this.state.showInput === true &&
                        <ClickOutHandler onClickOut={this.onClickOut}>
                            <div style={{display: 'inline-block'}}>
                                <input onKeyPress={(e) => this.onPressEnter(e, userId, photoURL)} value={this.state.name} style={{height: 34+'px', marginLeft: 5+'px', fontSize: 20}} onChange={e => this.onInputChange(e.target.value)} autoFocus></input>
                                <Button onClick={(e) => this.changeName(e, userId, photoURL)} style={{marginTop: -1, backgroundColor: '#ed1558', cursor: 'pointer', color: 'white', marginLeft: 10+'px'}} className='pull-right'>Change name</Button>
                            </div>
                        </ClickOutHandler>
                        }
                    <div>

                    {assignedTeams.length > 0 &&
                        <div>
                            <h4 style={{display: 'inline-block'}}>Team(s): </h4>
                                {assignedTeams.map((team,index) =>
                                    <h4 key={index} style={{display: 'inline-block', marginLeft: 5+'px'}}> 
                                        {team.teamName}
                                        {index !== assignedTeams.length-1 &&
                                            <span key={index+1} style={{display: 'inline-block'}}> , </span>
                                        }
                                    </h4>,
                                )}
                        </div>
                    }

                    <div className='divPositionEmail'>
                        <h5>Email: {user.email}</h5>
                    </div>

                    <div className='divPosition'>
                        {user.emailVerified ? (
                            <h5> (<Glyphicon glyph='ok'/> email verified) <Button onClick={() => {authStore.sendPasswordResetEmail(user)}} bsStyle='link' bsSize='xsmall'>reset password</Button></h5>) : (<Button onClick={() => {authStore.sendVerificationEmail(user)}} bsStyle='link'>(re-send verification email)</Button> ) }
                    </div>
                    </div>

                    {(userProfile && userProfile.plan_details) &&

                        <div>
                            {/* <div className='divPositionPlan'>
                                <h5>
                                Current Plan: 
                                <LinkContainer to='/plans'>
                                    {onFreePlan ? (
                                        <div>{userProfile.plan_details.displayName} <Button bsStyle='primary'>UPGRADE</Button></div>
                                    ):(
                                        <Button style={{marginTop: -5+'px'}} bsStyle='link'>{userProfile.plan_details.displayName}</Button>
                                    )}
                                </LinkContainer>
                                </h5>
                            </div> */}

                            <div className='divPositionIdea'>
                                {/* <h5>Ideas created: {userProfile.idea_count} 
                                    (of {userProfile.plan_details.idea_limit} on current plan)
                                    </h5> */}
                            </div>

                            {/* <div style={{marginTop: 10+'px'}}>
                                <h5>Attachments per idea: {userProfile.plan_details.attachments_per_idea}</h5>
                            </div>

                            <div style={{marginTop: 10+'px'}}>
                                <h5>Collaborators per idea: {userProfile.plan_details.collaborators_per_idea}</h5>
                            </div>

                            <div style={{marginTop: 10+'px'}}>
                                <h5>Images per idea: {userProfile.plan_details.images_per_idea}</h5>
                            </div> */}

                            {/* <div style={{marginTop: 10+'px'}}>
                                <h5>Price: {userProfile.plan_details.price}</h5>
                            </div> */}

                            {/*<div style={{marginTop: 10+'px'}}>
                                <h5>Sketches per idea: {userProfile.plan_details.sketches_per_idea}</h5>
                            </div>

                            <div style={{marginTop: 10+'px'}}>
                                <h5>Videos per idea: {userProfile.plan_details.videos_per_idea}</h5>
                            </div>*/}
                            
                        </div>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default inject("stores")(observer(UserProfile))



// WEBPACK FOOTER //
// ./src/containers/UserProfile.js